import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { TemplateService } from '../../services/template.service';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { CALENDAR_LOCALE } from '../../services/constant';
import * as moment from 'moment';

@Component({
  selector: 'app-saletax',
  templateUrl: './saletax.component.html',
  styleUrls: ['./saletax.component.scss'],
  providers: [TemplateService]
})
export class SaleTaxComponent implements OnInit {
  calendarLocale = CALENDAR_LOCALE.TH;
  selectedMonth = new Date(moment().format('YYYY') + '-01-01');
  searchInput = '';
  itemsPerPage = 40;
  totalItems = 0;
  currentPage = 1;
  loading = false;
  selectedMonthLabel = moment().format('MM/YYYY');

  constructor(
    private apiService: ApiService,
    private template: TemplateService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {}

  search() {}

  clearData() {}

  getSelectedMonth(e) {
    this.selectedMonth = new Date(moment(e).format('YYYY-MM') + '-01');
    this.selectedMonthLabel = moment(e).format('MM/YYYY');
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax.component.ts